import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const GET_LIST_TEAM_LICENSE_DETAIL = gql`
  query GetList($where: Map, $sort: Map) {
    GetTeamLicenseDetailList(
      pagination: { offset: 0, limit: 10, where: $where, sort: $sort }
    ) {
      ... on PaginationResponse {
        count
      }
      ... on TeamLicenseDetails {
        data {
          id
          role_id
          paid_at
          expired_at
          renewal_type
          grace_expired_at
          team_license_id
          renewal_type
          team_license {
            ... on TeamLicense {
              id
              license_id
              team_id
              team {
                ... on Team {
                  id
                  name
                  partner
                  limit
                  start_date
                  end_date
                  type
                  status
                  socmed_account_limit
                  created_at
                  updated_at
                  deleted_at
                }
              }
              created_at
              updated_at
              deleted_at
            }
          }
          license_type_id
          licenseType {
            ... on LicenseType {
              id
              name
              related_account
              description
              created_at
              updated_at
              deleted_at
            }
          }
          kuota
          subscription_type
          monthly_price
          annual_price
          biennial_price
          discount
          created_at
          updated_at
          deleted_at
        }
      }
    }
  }
`;
